import { Helmet } from 'react-helmet-async';

const siteConfig = {
  siteName: 'NeonSign',
  siteUrl: 'https://neonsign.dk',
  defaultTitle: 'NeonSign | Professionelle Skilte & Wayfinding siden 1994',
  defaultDescription: 'NeonSign leverer skiltning, wayfinding og facadeløsninger til virksomheder i hele Danmark. +30 års erfaring med komplekse projekter. Kontakt os i dag.',
  defaultImage: 'https://neonsign.dk/og-image.jpg',
};

export const SEO = ({ 
  title, 
  description, 
  image,
  pathname = '',
  noindex = false 
}) => {
  const pageTitle = title 
    ? `${title} | ${siteConfig.siteName}` 
    : siteConfig.defaultTitle;
  
  const pageDescription = description || siteConfig.defaultDescription;
  const pageImage = image || siteConfig.defaultImage;
  const canonicalUrl = `${siteConfig.siteUrl}${pathname}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Robots */}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:site_name" content={siteConfig.siteName} />
      <meta property="og:locale" content="da_DK" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />
      
      {/* Additional SEO */}
      <meta name="author" content="NeonSign ApS" />
      <meta name="geo.region" content="DK" />
      <meta name="geo.placename" content="Herlev" />
    </Helmet>
  );
};

export default SEO;
